import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { DealerMap } from 'client/tracking/maps/common/dealer';
import { TrackingConstant } from 'client/tracking/constant';
import { CompareVehicleTrayMap } from 'client/tracking/maps/common/compare-vehicle-tray';

const map = {
  view_cbp_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.VIEW_CBP_DETAILS
  ),

  view_price_now: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_PRICING_DETAILS
  ),

  view_appraisal_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_APPRAISAL_DETAILS
  ),

  find_similar_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.FIND_SIMILAR_VEHICLE
  ),

  view_search: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_SEARCH),

  close_filter_panel: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.CLOSE_FILTER_PANEL),

  remove_vehicle: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.REMOVE_VEHICLE),

  appraise_your_car: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.APPRAISE_YOUR_CAR
  ),

  appraise_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_APPRAISE_VEHICLE,
    TrackingConstant.INSIDER_APPRAISAL_CARD
  ),

  appraise_vehicle_view: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.INSIDER_APPRAISAL_CARD
  ),

  change_personal_info: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_UPDATE_MEMBERSHIP,
    TrackingConstant.CHANGE_PERSONAL_INFO
  ),

  select_own_vehicle: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.SELECT_OWN_VEHICLE),

  remove_own_vehicle: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.REMOVE_OWN_VEHICLE),

  begin_sign_in: TrackingEvent.actionStart(TrackingConstant.ACTION_SIGN_IN, TrackingConstant.BEGIN_SIGN_IN),

  create_password: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_UPDATE_MEMBERSHIP,
    TrackingConstant.CREATE_PASSWORD
  ),

  change_password: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_UPDATE_MEMBERSHIP,
    TrackingConstant.CHANGE_PASSWORD
  ),

  update_email_subscriptions: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_UPDATE_MEMBERSHIP,
    TrackingConstant.UPDATE_EMAIL_SUBSCRIPTIONS
  ),

  saved_search_remove: TrackingEvent.actionCompleted(
    TrackingConstant.SAVE_VEHICLE,
    TrackingConstant.REMOVE_SEARCH_TRIGGER
  ),

  saved_search_remove_confirmed: TrackingEvent.actionCompleted(
    TrackingConstant.SAVE_VEHICLE,
    TrackingConstant.REMOVE_SEARCH
  ),

  search_card_click: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_SEARCH),

  favorite_model_card_click: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SUBMIT_MMY
  ),

  compare_cars_and_read_reviews: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_REVIEW,
    TrackingConstant.VIEW_EDMUNDS_REVIEW
  ),

  find_more_cars_like_this: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TYPE_SELECT,
    TrackingConstant.ACTION_TYPE_SELECT
  ),

  view_suggested_vin: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SUGGESTED_VIN
  ),

  view_suggested_price_drop: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SUGGESTED_PRICE_DROP
  ),

  unsave_model: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.UNSAVE_MODEL),

  view_recently_viewed_vins: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_CONTENT
  ),

  srp_link_click: TrackingEvent.actionCompleted(
    TrackingConstant.VIEW_SEARCH_RESULT,
    TrackingConstant.VIEW_SEARCH_RESULT
  ),

  price_breakdown_link_click: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_BUILD_DETAILS
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...DealerMap,
  ...CompareVehicleTrayMap,
  ...map,
};
